import { Badge } from "@/components/ui/badge";

const MAP = {
  attivo: "bg-green-100 text-green-800 border-green-200",
  da_rinnovare: "bg-blue-100 text-blue-800 border-blue-200",
  sospeso: "bg-amber-100 text-amber-800 border-amber-200",
  cessato: "bg-rose-100 text-rose-700 border-rose-300",
  dismesso: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

const LABEL = {
  attivo: "Attivo",
  da_rinnovare: "Da rinnovare",
  sospeso: "Sospeso",
  cessato: "Cessato",
  dismesso: "Dismesso",
};

const cap = (s) => (s ? String(s).charAt(0).toUpperCase() + String(s).slice(1) : s);

export function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      className={`rounded-sm font-medium ${MAP[status] || "bg-zinc-100 text-zinc-700"}`}
    >
      {LABEL[status] || cap(status)}
    </Badge>
  );
}

export function TypeBadge({ tipo }) {
  const map = {
    canone: "bg-blue-50 text-primary border-blue-200",
    consumo: "bg-violet-50 text-violet-700 border-violet-200",
    misto: "bg-indigo-50 text-indigo-700 border-indigo-200",
  };
  const label = { canone: "Canone", consumo: "Consumo", misto: "Misto" };
  return (
    <Badge variant="outline" className={`rounded-sm font-medium ${map[tipo] || ""}`}>
      {label[tipo] || tipo}
    </Badge>
  );
}
